/**
 * PK-14: canlı temanın "Daha Fazlasını Yükle" butonu.
 * Horizon sonsuz kaydırmayla sonraki sayfayı, ızgaranın altındaki `[ref="viewMoreNext"]` işaretçisi görünür
 * olduğunda yükler. pk-collection.css bu işaretçiyi gizler; buton tıklanınca (ya da tamamen ekrana girince,
 * KAN-74) işaretçi bir kez açılır, Horizon sayfayı ekler, ardından işaretçi yeniden gizlenir. Son sayfada buton kaldırılır.
 */

const LABEL = /** @type {{ loadMore?: string }} */ (window.pkStrings || {}).loadMore || 'Daha Fazlasını Yükle';

/** @param {HTMLElement} sentinel */
function setup(sentinel) {
  if (sentinel.dataset.pkLoadMore) return;
  sentinel.dataset.pkLoadMore = 'true';

  const grid = sentinel.parentElement?.querySelector('ul.product-grid');
  if (!grid) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'pk-load-more';
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'button pk-load-more__button';
  button.textContent = LABEL;
  wrapper.append(button);
  sentinel.after(wrapper);

  const lastPage = Number(grid.dataset.lastPage || 1);
  const currentPage = () =>
    Math.max(1, ...[...grid.querySelectorAll('[data-page]')].map((el) => Number(/** @type {HTMLElement} */ (el).dataset.page) || 1));

  const update = () => {
    wrapper.hidden = currentPage() >= lastPage;
  };

  // Canlı Minimog'daki "infinite" sayfalama (tüm koleksiyon şablonlarında açıktı): buton görünür kalır, tamamen
  // ekrana girince sonraki sayfa kendiliğinden yüklenir. Kök verilmedi; ≥990 px'teki .page-wrapper kaydırmasında da
  // görünürlük doğru hesaplanıyor (rootMargin kullanılmadığı için).
  const autoLoad = new IntersectionObserver(
    (entries) => {
      if (entries.some((entry) => entry.intersectionRatio >= 0.99) && !wrapper.hidden && !button.hasAttribute('aria-busy')) {
        button.click();
      }
    },
    { threshold: 1 }
  );

  const observer = new MutationObserver(() => {
    if (!sentinel.classList.contains('pk-load-more-armed')) return;
    sentinel.classList.remove('pk-load-more-armed');
    button.removeAttribute('aria-busy');
    update();
    if (wrapper.hidden) {
      autoLoad.disconnect();
    } else {
      // Eklenen ürünlerden sonra buton hâlâ ekrandaysa gözlemci yeniden değerlendirsin.
      autoLoad.unobserve(button);
      autoLoad.observe(button);
    }
  });
  observer.observe(grid, { childList: true });

  button.addEventListener('click', () => {
    if (button.hasAttribute('aria-busy')) return;
    button.setAttribute('aria-busy', 'true');
    sentinel.classList.add('pk-load-more-armed');
  });

  update();
  if (!wrapper.hidden) autoLoad.observe(button);
}

function init() {
  for (const sentinel of document.querySelectorAll('.main-collection-grid [ref="viewMoreNext"]')) {
    if (sentinel instanceof HTMLElement) setup(sentinel);
  }
}

init();
// Filtre/sıralama değişince Horizon ızgarayı yeniden render eder; yeni işaretçiler için tekrar kur.
new MutationObserver(init).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
